export const userStatusLabels = {
  active: "Активен",
  pending: "Приглашен",
};

export const usersConfig = {
  Активен: {
    label: "Активен",
    className: "bg-green-500 hover:bg-green-600 text-white min-w-[110px] justify-center",
  },
  Заблокирован: {
    label: "Заблокирован",
    className: "bg-grey-500 hover:bg-grey-600 text-white min-w-[110px] justify-center",
  },
  Приглашён: {
    label: "Приглашён",
    className: "bg-red-500 hover:bg-red-600 text-white min-w-[110px] justify-center",
  },
};
